// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAD5LMM7scwlG0uhRYHt4iYlFxwt8Rh7rY",
  authDomain: "droshipping-5ff02.firebaseapp.com",
  projectId: "droshipping-5ff02",
  storageBucket: "droshipping-5ff02.firebasestorage.app",
  messagingSenderId: "1085155839109",
  appId: "1:1085155839109:web:920081c9eb301b38776dec",
  measurementId: "G-EM9KVJP9L2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage
const storage = getStorage(app);

export { storage };
